import React, { useState } from 'react'
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import { CommonModal } from '../../../../Components/common/CommonFunctions';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify'
import Select from 'react-select';
import AddAttachment from '../../../../Components/common/AddAttachment';

const Tasks = () => {
    const [openModal, setOpenModal] = useState(false)
    const [formData, setFormData] = useState({}) 
    const [templateData, setTemplateData] = useState([])
    const [userData, setUserData] = useState([])
    const createTask = () => {
        setOpenModal(true)
    }
    const modalClose = () => {
        setOpenModal(false)
    }
    const HandleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const imageChange = (img) => {
        setFormData(prev => ({
            ...prev,
            file: img
        }))
    }
    const handleSave = () => {

    }

    const filtersConfig = [
        {
            type: "button",
            text: "Create Task",
            click: createTask,
            icon: 'plus'
        },
        {
            type: "multiselect",
            field: "status",
            placeholder: "status",
            options: [],
            // warehouse?.map((item) => ({
            //     label: item.name,
            //     value: item.id,
            // })) || [],
        },
        {
            type: "input",
            field: "assign_to",
            placeholder: "Assign To",
        },
    ];
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <TableFilters filtersConfig={filtersConfig} />
            </div>
            <CommonModal
                show={openModal}
                onHide={modalClose}
                title='Create Task'
                subTitle='Define and assign a new task'
                className='addfrom primary_modal'
                footer={
                    <div className='d-flex'>
                        <Button variant="secondary" onClick={modalClose}> Discard </Button>
                        <Button variant="primary" onClick={handleSave} className="ms-auto"> Save </Button>
                    </div>
                }>
                <Form.Group className='mb-2'>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                        type='text'
                        placeholder="Title"
                        name="title"
                        value={formData.title}
                        onChange={HandleChange}
                    />
                </Form.Group>
                <Form.Group className='mb-2'>
                    <Form.Label>Use template</Form.Label>
                    <Select
                        options={templateData}
                        onChange={selected =>
                            setFormData(prev => ({
                                ...prev,
                                template_id: selected.value
                            }))
                        }
                        placeholder="Select Template"
                        className="down_selct"
                        name="group_id"
                        value={templateData?.find(option => option.value === formData.template_id) || null}
                    />
                </Form.Group>
                <Form.Group className='mb-2'>
                    <Form.Label>Assignment and notifications</Form.Label>
                    <Form.Label>Assign to</Form.Label>
                    <div className='d-flex'>
                        {['myself', 'person', 'department'].map((name) => (
                            <div className="mb-2" key={`inline-${name}`}>
                                <Form.Check
                                    inline
                                    label={name === 'myself' ? 'Myself' : name === 'person' ? 'A Person' : 'Department'}
                                    name={name}
                                    type='radio'
                                    id='export'
                                    value='E'
                                    checked={formData.booking_type === 'E'}
                                    onChange={HandleChange}
                                />
                            </div>
                        ))}
                    </div>
                </Form.Group>
                <Form.Group className='mb-2'>
                    <Form.Label>Assigned user</Form.Label>
                    <Select
                        options={userData}
                        onChange={selected =>
                            setFormData(prev => ({
                                ...prev,
                                user_id: selected.value
                            }))
                        }
                        placeholder="Select User"
                        className="down_selct"
                        name="group_id"
                        value={userData?.find(option => option.value === formData.user_id) || null}
                    />
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>Due date</Form.Label>
                    <Form.Control
                        type="date"
                        name="due_date"
                        value={formData.due_date}
                        onChange={HandleChange}
                    />
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>Notifications</Form.Label>
                    <Select
                        options={userData}
                        onChange={selected =>
                            setFormData(prev => ({
                                ...prev,
                                user_id: selected.value
                            }))
                        }
                        placeholder="Quick setup the Due & Reminder date"
                        className="down_selct"
                        name="group_id"
                        value={userData?.find(option => option.value === formData.user_id) || null}
                    />
                </Form.Group>
                <Form.Group>
                    <AddAttachment
                        sendData={imageChange}
                    />
                </Form.Group>
            </CommonModal>
        </div>
    )
}

export default Tasks